  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
     <div class="title">
      <span class="icon">$</span>
      <span *ngIf="incomeID==0" class="title-text">Add Income - </span> <b *ngIf="incomeID==0" style="color: #2e5bff;"> {{ selectedCoreName }}</b>
      <span *ngIf="incomeID>0" class="title-text">Update Income - </span> <b *ngIf="incomeID>0" style="color: #2e5bff;"> {{ selectedCoreName }}</b>

      <!-- <span class="title-text">Add Income - {{selectedCoreName}}</span> -->
    </div>
    <button mat-icon-button (click)="closeDialog()" >
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>

  <mat-dialog-content>
  <div class="add-income-modal">

  <div class="modal-body">

    <label class="form-label">Name of Income</label>
    <input matInput placeholder="e.g., Social Security, Pension" class="form-control" 
     formControlName="title"/>

    <label class="form-label">Amount</label>
    <div class="input-prefix">
      <span>$</span>
      <input matInput placeholder="0.00" (keypress)="numberOnly($event)"  class="form-control"
      formControlName="amount"/>
    </div>

    <label class="form-label">Note</label>
    <textarea matInput class="form-textarea" placeholder="Add any relevant notes..."
     formControlName="description"></textarea>

   <div class="row-box">

  <div class="field-box">
    <label class="form-label">Frequency</label>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Select Option</mat-label>
      <mat-select name="frequency" formControlName="frequency">
        <mat-option value="1">Monthly</mat-option>
        <mat-option value="2">Yearly</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="field-box">
    <label class="form-label">Verification Status</label>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Select Option</mat-label>
      <mat-select name="verificationStatus" formControlName="verificationStatus">
        <mat-option value="1">Pending Verification</mat-option>
        <mat-option value="2">Verified</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  

   </div>

 <label class="form-label">Type</label>
    <mat-radio-group formControlName="type" class="primary">
    <mat-radio-button value="0">Resident</mat-radio-button> &nbsp;&nbsp;
    <mat-radio-button value="1">Spouse</mat-radio-button>
    </mat-radio-group>

  </div>

   <!-- <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="closeDialog()">Cancel</button>
    <button mat-flat-button color="primary"    
    [disabled]="formDialog.invalid || !formDialog.dirty"
    (click)="addIncomeForPDPMCore(formDialog.value)">Add Income
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
  </mat-dialog-actions> -->

  <div class="modal-footer">
    <button mat-button (click)="closeDialog()" class="cancel-btn">Cancel</button>

    <button *ngIf="incomeID==0" mat-flat-button color="primary"  [disabled]="formDialog.invalid || !formDialog.dirty"
    (click)="addIncomeForPDPMCore(formDialog.value)">Save
     <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
    </button>

    <button *ngIf="incomeID>0" mat-flat-button color="primary"  [disabled]="formDialog.invalid || !formDialog.dirty"
    (click)="addIncomeForPDPMCore(formDialog.value)">Update
     <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
    </button>

  </div>

  </div>
 
  </mat-dialog-content>
  </form>
  




  

  




